import { Injectable } from '@angular/core';
import { ICashRegisterVendorInterface } from './cash-register-vendor.interface';
import { OmnisoftService } from './vendor/omnisoft/omnisoft.service';
import { CashRegisterVendorTypeEnum } from '../../../enum/cash-register/cash-register-vendor-type-enum';
import { SmartOneService } from './vendor/smart-one/smart-one.service';
import { NbasoftService } from './vendor/nbasoft/nbasoft.service';
import { PavoService } from './vendor/pavo/pavo.service';
import { CasposService } from './vendor/caspos.service';

@Injectable({
    providedIn: 'root',
})
export class CashRegisterFactoryService {
    constructor(
        private omnisoftService: OmnisoftService,
        private smartOneService: SmartOneService,
        private nbasoftService: NbasoftService,
        private pavoService: PavoService,
        private casposService: CasposService,
    ) { }

    getVendorService(vendorType: string): ICashRegisterVendorInterface {
        switch (vendorType) {
            case CashRegisterVendorTypeEnum.OMNISOFT:
                return this.omnisoftService;
            case CashRegisterVendorTypeEnum.SMARTONE:
                return this.smartOneService;
            case CashRegisterVendorTypeEnum.NBASOFT:
                return this.nbasoftService;
            case CashRegisterVendorTypeEnum.PAVO:
                return this.pavoService;
            case CashRegisterVendorTypeEnum.CASPOS:
                return this.casposService;
            default:
                throw new Error(`Unsupported vendor type: ${vendorType}`);
        }
    }
}